<script setup lang="ts">
import { computed } from 'vue'
import { differenceInMilliseconds } from 'date-fns'
import Checkbox from 'primevue/checkbox'

// Vue 2 measured with moment's duration.asMonths(), a fixed average month rather than calendar months.
const AVERAGE_MONTH_IN_MS = (146097 / 4800) * 24 * 60 * 60 * 1000
const NEW_DURATION_IN_MONTHS = 4

const props = withDefaults(
  defineProps<{
    label: string
    value: string
    inputId: string
    dateAdded?: Date | null
  }>(),
  {
    dateAdded: null
  }
)

const selectedValues = defineModel<string[]>({ required: true })

function monthsSince(date: Date): number {
  return differenceInMilliseconds(new Date(), date) / AVERAGE_MONTH_IN_MS
}

const isNew = computed(() => props.dateAdded instanceof Date && monthsSince(props.dateAdded) <= NEW_DURATION_IN_MONTHS)
</script>

<template>
  <div class="flex items-center gap-3 py-1">
    <Checkbox v-model="selectedValues" :value="value" :input-id="inputId" />
    <label :for="inputId" class="mb-0 text-text-2xl font-regular">
      {{ label }}
      <span v-if="isNew" class="rounded-xs bg-success px-1.5 py-0.5 align-top text-xs font-bold uppercase text-white">New</span>
    </label>
  </div>
</template>
